module.exports = __webpack_public_path__ + "img/marker_four_red1.ac2bb7e9.png";